import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart, Users, Calendar, Gift } from 'lucide-react';
import { getYearFromTimestamp } from '../Utils/dateHelpers';

const PersonalEvents = ({ events, loading, isLoggedIn, userid }) => {
  if (!isLoggedIn) {
    return null;
  }

  if (loading) {
    return (
      <section className="events-section personal-events-section">
        <div className="section-header">
          {/* <h2 className="section-title">Personal Celebrations</h2> */}
        </div>
        <div className="loading-spinner-small">
          Loading your personal events{userid ? ` for ${userid}` : ''}...
        </div>
      </section>
    );
  }

  if (!events || events.length === 0) {
    return (
      <section className="events-section personal-events-section">
        <div className="section-header">
          <h2 className="hp-section-title" style={{color: "white" }}>Personal Celebrations</h2>
        </div>
        <div className="empty-state">
          <p>No personal events yet. Add birthdays, anniversaries, and special moments!</p>
          <button 
            className="add-personal-event-btn"            
            onClick={() => console.log('Add personal event for user:', userid)}
          >
            + Add Personal Event
          </button>
        </div>
      </section>
    );
  }

  return (
    <section className="events-section personal-events-section">
      <div className="section-header">
        <h2 className="section-title">Personal Celebrations ({events.length})</h2>
      </div>
      <div className="event-list">
        {events.map((event) => (
          <Link
            key={event.id}
            to={`/event-page?eventname=${event.eventid}&year=${getYearFromTimestamp(event.event_timestamp)}`}
            style={{ textDecoration: "none" }}
          >
            <motion.div
              className="event-sticker medium personal-event"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              style={{background: "rgba(36,36,45,0.2)", border: "1px solid darkslategray"}}
            >
              <img
                src={event.eventimageurl}
                alt={event.eventname}
                className="event-image"
              />
              <div className="event-badge" style={{color: "white"}}>{event.eventType}</div>
              {event.reminderSet && (
                <div className="reminder-indicator">
                  <Calendar size={12} /> Reminder On
                </div>
              )}
              <h4 className="event-title" style={{color: "white"}}>{event.eventname}</h4>
              {event.relationship && (
                <p className="event-relationship">{event.relationship}</p>
              )}
              {event.giftIdeas && event.giftIdeas.length > 0 && (
                <p className="event-gift-ideas">
                  <Gift size={12} /> {event.giftIdeas.length} gift ideas
                </p>
              )}
              <p className="event-date" style={{color: "white"}}>
                {new Date(event.event_timestamp).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                })}
              </p>
            </motion.div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PersonalEvents;
